exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-admin-links-component table {\n  min-width: 1200px !important;\n}", ""]);

// exports
